import React from 'react';
import bem from 'utils/bem';

import './index.sass';

const { block, el } = bem('mobile-menu-button');
const MobileMenuButton = ({ mod, onClick }) => {
    return (
        <div className={ block(mod) }
             onClick={ onClick }
             role='button'
        >
            <div className={el('bar-container')}>
                <div className={ el('bar') }/>
                <div className={ el('bar') }/>
                <div className={ el('bar') }/>
            </div>
        </div>
    );
}

export default MobileMenuButton;
